import { normaliseAnswer } from './utils.js';

const PASSAGE_TOKEN = /\{\{blank_([1-5])\}\}/gu;

export const GUIDED_MAXIMUM = 10;

export function storedGuidedPassage(headword) {
  return headword?.guidedPracticePassage ?? null;
}

export function guidedScore(choiceStates, passageMarks) {
  const choiceScore = (choiceStates ?? []).filter((state) => state.mark === true).length;
  const passageScore = Object.values(passageMarks ?? {}).filter(Boolean).length;
  return choiceScore + passageScore;
}

export function passageParts(text) {
  const source = String(text ?? '');
  const parts = [];
  let position = 0;
  for (const match of source.matchAll(PASSAGE_TOKEN)) {
    if (match.index > position) parts.push({ type: 'text', text: source.slice(position, match.index) });
    parts.push({ type: 'blank', number: Number(match[1]), token: match[0] });
    position = match.index + match[0].length;
  }
  if (position < source.length) parts.push({ type: 'text', text: source.slice(position) });
  return parts;
}

export function acceptedPassageAnswer(response, blank) {
  const answer = normaliseAnswer(response);
  if (!answer) return false;
  return (blank.acceptedAnswers ?? [blank.answer])
    .some((candidate) => normaliseAnswer(candidate) === answer);
}

export function completedPassage(passage) {
  let text = String(passage?.textWithBlanks ?? '');
  for (const blank of passage?.blanks ?? []) {
    text = text.replace(blank.token, blank.answer);
  }
  return text;
}

export function blankResponses(blanks) {
  return Object.fromEntries((blanks ?? []).map((blank) => [blank.id, '']));
}
